import loadable from '@loadable/component';
export const manifest = {
  'SmeReshala.SearchAutocomplete': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaSearchAutocompleteDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaSearchAutocompleteDesktop" */
          './search-autocomplete-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./search-autocomplete-desktop");
            }

            return eval('require.resolve')("./search-autocomplete-desktop");
          }

        }, {
          resolveComponent: m => m.SearchAutocompleteDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaSearchAutocompleteMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaSearchAutocompleteMobile" */
          './search-autocomplete-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./search-autocomplete-mobile");
            }

            return eval('require.resolve')("./search-autocomplete-mobile");
          }

        }, {
          resolveComponent: m => m.SearchAutocompleteMobile
        })
      }
    }
  },
  'SmeReshala.IteratorWrapper': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaIteratorWrapper";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaIteratorWrapper" */
          './iterator-wrapper'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./iterator-wrapper");
            }

            return eval('require.resolve')("./iterator-wrapper");
          }

        }, {
          resolveComponent: m => m.IteratorWrapper
        })
      }
    }
  },
  'SmeReshala.TabsPannelWrapper': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaTabsPannelWrapper";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaTabsPannelWrapper" */
          './tabs-pannel-wrapper'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./tabs-pannel-wrapper");
            }

            return eval('require.resolve')("./tabs-pannel-wrapper");
          }

        }, {
          resolveComponent: m => m.TabsPannelWrapper
        })
      }
    }
  },
  'SmeReshala.ModalControl': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaModalControl";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaModalControl" */
          './modal-control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./modal-control");
            }

            return eval('require.resolve')("./modal-control");
          }

        }, {
          resolveComponent: m => m.ModalControl
        })
      }
    }
  },
  'SmeReshala.SelectOptionDadata': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaSelectOptionDadataDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaSelectOptionDadataDesktop" */
          './select-option-dadata-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./select-option-dadata-desktop");
            }

            return eval('require.resolve')("./select-option-dadata-desktop");
          }

        }, {
          resolveComponent: m => m.SelectOptionDadataDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeReshalaSelectOptionDadataMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeReshalaSelectOptionDadataMobile" */
          './select-option-dadata-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./select-option-dadata-mobile");
            }

            return eval('require.resolve')("./select-option-dadata-mobile");
          }

        }, {
          resolveComponent: m => m.SelectOptionDadataMobile
        })
      }
    }
  }
};